import React from 'react';
import buildInfo from '../../buildInfo.json';

/**
 * Tiny admin-only build badge so we can instantly tell whether production
 * is on the latest deploy vs. a stale one. Shows short git SHA + relative
 * build time. Visible only to admins to avoid leaking deploy cadence to
 * end users.
 */
const formatRelative = (iso) => {
  if (!iso) return '';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  const diffMs = Date.now() - then;
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(iso).toLocaleDateString();
};

const BuildBadge = ({ user }) => {
  if (user?.role !== 'admin') return null;
  const sha = buildInfo?.sha || 'dev';
  const builtAt = buildInfo?.builtAt;
  const absolute = builtAt ? new Date(builtAt).toLocaleString() : '';
  return (
    <div
      className="px-3 pb-2 pt-1 text-[10px] font-mono text-slate-400 leading-tight select-text"
      title={`Built ${absolute}`}
      data-testid="build-badge"
    >
      <span data-testid="build-badge-sha">build {sha}</span>
      {builtAt && (
        <>
          <span className="mx-1">·</span>
          <span data-testid="build-badge-time">{formatRelative(builtAt)}</span>
        </>
      )}
    </div>
  );
};

export default BuildBadge;
